import(/* webpackMode: "eager" */ "/codebuild/output/src4070175448/src/apps/fanychance/src/app/error.tsx");
